// extracted by mini-css-extract-plugin
export default {"skillsContainer":"Skills_skillsContainer__Yn8I2","title":"Skills_title__9owSu","items":"Skills_items__TteTG","skillsSection":"Skills_skillsSection__90bWD"};